module.exports = "//public.getcloudapp.com/packs/media/images/zight-logomark-white-6753b9e3540f66dc069e9ebd3f9cb7e8.svg";